import React from 'react';
import MainNavigation from './MainNavigation';
import CategoriesNavigation from './CategoriesNavigation';
import ProvidersNavigation from './ProvidersNavigation';
import { useSidebarNavigation } from './hooks';
import { getDataTestAttributes } from '../../../utils/testing-locators';
import { TAB_NAVIGATION } from '../../../constants/dataTestIds';
import arePropsEqual from 'react-fast-compare';

const UnifiedNavigation: React.FC = () => {
  const { main, isLoading, categories, providers } = useSidebarNavigation();

  return (
    <nav role="navigation" {...getDataTestAttributes(TAB_NAVIGATION)}>
      <MainNavigation isLoading={isLoading} items={main} sectionIndex={0} />
      <CategoriesNavigation
        isLoading={isLoading}
        items={categories}
        sectionIndex={1}
      />
      <ProvidersNavigation
        isLoading={isLoading}
        items={providers}
        sectionIndex={categories?.length ? 2 : 1}
      />
    </nav>
  );
};

export default React.memo(UnifiedNavigation, arePropsEqual);
